<template>
    <div class="home">
        <NavBar />
        <div class="d-flex justify-content-center">
            <InviteDetails />
        </div>
    </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';
import InviteDetails from '@/components/InviteViewComponents/InviteDetails.vue';
export default {
    name: 'InviteView',
    components: { 
        NavBar,
        InviteDetails
     }
}
</script> 